<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>系统管理员账号</h6>
      <soft-button
        class="my-4 mb-2"
        variant="gradient"
        color="success"
        :loading="loading"
        @click="openDialog">
        +添加账号
      </soft-button>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                登录名
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                角色
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                账号状态
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                创建时间
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(operator, index) in operatorList" :key="operator.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="getAvatar(index)"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user1"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ operator.Name }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">管理员</p>
                <p class="text-xs text-secondary mb-0">系统管理员</p>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge
                  v-if="operator.OperatorIps.length > 0" 
                  color="success"
                  variant="gradient"
                  size="sm"
                >
                  在线
                </soft-badge>
                <soft-badge
                  v-else
                  color="secondary"
                  variant="gradient"
                  size="sm"
                >
                  离线
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold"
                  >{{ formatCreatedDate(operator.CreatedDate) }}</span
                >
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  @click="deleteAccount(operator.Id)"
                  data-toggle="tooltip"
                  data-original-title="Delete user"
                  >
                  删除
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!--add account dialog-->
  <div v-if="showDialog" class="overlay">
     <div class="dialog">
       <h4>添加账号</h4>
       <div class="form-group">
         <label for="account">账号</label>
         <input type="text" id="account" v-model="newAccount" class="form-control" />
       </div>
       <div class="form-group">
         <label for="password">密码</label>
         <input type="password" id="password" v-model="newPassword" class="form-control" />
       </div>
       <div class="dialog-actions">
         <button class="btn btn-danger" @click="closeDialog">取消</button>
         <button class="btn btn-success" :disabled="loading" @click="addAccount">确定</button>
       </div>
     </div>
   </div>

</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import SoftButton from "@/components/SoftButton.vue";
import { operatorinfo, addAcc, delAcc } from "@/api/main.js";
import md5 from "md5";
import dayjs from 'dayjs';
import store from '@/store'

export default {
  name: "authors-table",
  data() {
    return {
      operatorList:[],
      loading:false,
      showDialog:false,
      newAccount:"",
      newPassword:"",
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
    SoftButton,
  },
  mounted() {
    this.fetchOperatorList();
  },
  methods: {
    fetchOperatorList(){
      operatorinfo().then((response) => {
        console.log("fetch list:", response);
        if (response.code === 0) {
          this.operatorList = response.desc
        }
      })
      .catch((error) => {
        console.log("get operator list err:", error)
      })
    },
    getAvatar(index) {
      const avatars = [require("../../assets/img/team-1.jpg"),require("../../assets/img/team-2.jpg"),require("../../assets/img/team-3.jpg"),require("../../assets/img/team-4.jpg")]
      return avatars[index % avatars.length]
    },
    formatCreatedDate(unixtime) {
      return dayjs.unix(unixtime).format('YYYY/MM/DD HH:mm:ss')
    },

    openDialog(){
      this.showDialog = true
    },

    closeDialog(){
      this.showDialog = false
      this.newAccount = ''
      this.newPassword = ''
    },

    addAccount(){
      if (!this.newAccount || !this.newPassword) {
        alert('账号密码不能为空')
        return
      }
      this.loading = true
      const encPwd = md5(this.newPassword + this.newAccount)
      addAcc({
        account: this.newAccount, 
        password: encPwd})
        .then((response)=>{
          this.loading = false
          this.closeDialog()
          this.fetchOperatorList()
          alert(response.desc)
        })
        .catch((error)=>{
          this.loading = false
          console.log("add account err:", error)
          alert('添加失败，稍后再试')
          this.closeDialog()
          this.fetchOperatorList()
        })

    },

    deleteAccount(targetUid) {
      const currentUserId = this.getCurrentUserId()
      console.log("operator id:", currentUserId)
      if (confirm("确定要删除这个账号？")) {
        this.loading = true 
        delAcc({
          uid: currentUserId,
          target_uid: targetUid})
          .then((response)=>{
            this.loading = false 
            if (response.code === 0){
              alert("账号删除成功!")
              this.fetchOperatorList()
            }else{
              alert(response.desc||"删除失败")
            }
          })
          .catch((error)=>{
            this.loading = false
            console.log("delete account err:", error)
            alert("删除失败，稍后再试")
          })
      }
    },

    getCurrentUserId(){
      return store.getters.token.id
    }

  }
};
</script>
